import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import MessagePage, { Addresses } from './MessagePage';
import userApi from '../../Api/userApi';
import { GA_EVENT_TREE } from '../../gaConstants';
import { CARD } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

// What a pilot includes: the same four points the schools card makes.
const POINTS = [1, 2, 3, 4].map((n) => `redesign.home.schools.point${n}`);

const useStyles = makeStyles(() => ({
    // The side card, on the amber surface the landing's schools card uses.
    side: {
        ...CARD,
        padding: 'clamp(22px, 2.8vw, 30px)',
        borderColor: REDESIGN_COLORS.amberBorder,
        background: REDESIGN_COLORS.amberSurface,
    },
    title: {
        margin: '0 0 14px',
        fontSize: '1.2rem',
        letterSpacing: '-0.02em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    points: {
        display: 'grid',
        gap: '11px',
        margin: 0,
        padding: 0,
        listStyle: 'none',
        color: REDESIGN_COLORS.dark,
        fontSize: '0.95rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
    },
    point: {
        display: 'flex',
        gap: '10px',
    },
    tick: {
        color: REDESIGN_COLORS.primary,
        fontWeight: REDESIGN_FONTS.weightHeading,
    },
    rule: {
        height: '1px',
        margin: '22px 0',
        background: REDESIGN_COLORS.amberBorderStrong,
    },
}));

/**
 * The "ask for a pilot" page for schools: the shared message form beside a
 * card that says what a pilot includes. Sends the special-quota email.
 */
const SpecialQuotaPage = () => {
    const classes = useStyles();

    useEffect(() => {
        window.logAppActivity(GA_EVENT_TREE.mainPage.onboarding.wantOffer);
    }, []);

    const side = (
        <aside className={classes.side}>
            <h2 className={classes.title}>
                <FormattedMessage id="redesign.quota.includes.title" />
            </h2>
            <ul className={classes.points}>
                {POINTS.map((id) => (
                    <li key={id} className={classes.point}>
                        <span aria-hidden="true" className={classes.tick}>
                            ✓
                        </span>
                        <FormattedMessage id={id} />
                    </li>
                ))}
            </ul>
            <div aria-hidden="true" className={classes.rule} />
            <Addresses />
        </aside>
    );

    return (
        <MessagePage
            keyPrefix="redesign.quota"
            eyebrowId="redesign.home.schools.eyebrow"
            send={({ name, email, phone, message }) => userApi.sendSpecialQuotaEmail({ name, email, phone, message })}
            side={side}
        />
    );
};

export default SpecialQuotaPage;
